import { useState } from 'react';

interface Department {
  code: string;
  name: string;
  cities: string[];
  delay: string;
  description: string;
  mapUrl: string;
}

const departments: Department[] = [
  {
    code: '75',
    name: 'Paris',
    cities: ['Paris 1er', 'Paris 8e', 'Paris 16e', 'Paris 18e', 'Marais', 'Montmartre'],
    delay: '30 min',
    description: 'Livraison express dans tous les arrondissements de Paris. Coursier moto pour éviter les embouteillages.',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d83998.94722687195!2d2.277019!3d48.8588897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66e1f06e2b005%3A0x40b82c3688c9460!2sParis!5e0!3m2!1sfr!2sfr!4v1234567890'
  },
  {
    code: '92',
    name: 'Hauts-de-Seine',
    cities: ['Nanterre', 'Boulogne-Billancourt', 'Courbevoie', 'La Défense', 'Levallois-Perret', 'Neuilly-sur-Seine'],
    delay: '45 min',
    description: 'Transport rapide dans les Hauts-de-Seine. Service optimisé pour La Défense et les zones d\'affaires.',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d167645.89308255615!2d2.1889019!3d48.8566969!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e664f1b8e3e8e5%3A0x40b82c3688c9460!2sHauts-de-Seine!5e0!3m2!1sfr!2sfr!4v1234567891'
  },
  {
    code: '93',
    name: 'Seine-Saint-Denis',
    cities: ['Saint-Denis', 'Montreuil', 'Aubervilliers', 'Bobigny', 'Pantin', 'Le Bourget'],
    delay: '50 min',
    description: 'Livraison en Seine-Saint-Denis avec accès rapide aux zones industrielles et commerciales.',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d167645.89308255615!2d2.4389019!3d48.9066969!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e66e1f06e2b005%3A0x40b82c3688c9460!2sSeine-Saint-Denis!5e0!3m2!1sfr!2sfr!4v1234567892'
  },
  {
    code: '94',
    name: 'Val-de-Marne',
    cities: ['Créteil', 'Vitry-sur-Seine', 'Champigny-sur-Marne', 'Saint-Maur-des-Fossés', 'Ivry-sur-Seine', 'Vincennes'],
    delay: '50 min',
    description: 'Service de transport dans le Val-de-Marne. Livraison rapide vers les entreprises et particuliers.',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d167645.89308255615!2d2.4889019!3d48.7866969!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e673f1b8e3e8e5%3A0x40b82c3688c9460!2sVal-de-Marne!5e0!3m2!1sfr!2sfr!4v1234567893'
  },
  {
    code: '91',
    name: 'Essonne',
    cities: ['Évry-Courcouronnes', 'Corbeil-Essonnes', 'Massy', 'Savigny-sur-Orge', 'Palaiseau', 'Yerres'],
    delay: '60 min',
    description: 'Transport en Essonne avec couverture complète du département. Idéal pour les zones d\'activités.',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d335291.78616511230!2d2.1889019!3d48.6366969!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e5e1f06e2b005%3A0x40b82c3688c9460!2sEssonne!5e0!3m2!1sfr!2sfr!4v1234567894'
  },
  {
    code: '78',
    name: 'Yvelines',
    cities: ['Versailles', 'Sartrouville', 'Mantes-la-Jolie', 'Saint-Germain-en-Laye', 'Poissy', 'Conflans-Sainte-Honorine'],
    delay: '60 min',
    description: 'Livraison dans les Yvelines. Service adapté aux zones résidentielles et d\'affaires.',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d335291.78616511230!2d1.8889019!3d48.8066969!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e681f06e2b005%3A0x40b82c3688c9460!2sYvelines!5e0!3m2!1sfr!2sfr!4v1234567895'
  },
  {
    code: '95',
    name: 'Val-d\'Oise',
    cities: ['Cergy', 'Argenteuil', 'Sarcelles', 'Pontoise', 'Garges-lès-Gonesse', 'Franconville'],
    delay: '60 min',
    description: 'Transport dans le Val-d\'Oise. Accès rapide aux zones industrielles et commerciales du nord.',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d335291.78616511230!2d2.1889019!3d49.0566969!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e6e1f06e2b005%3A0x40b82c3688c9460!2sVal-d%27Oise!5e0!3m2!1sfr!2sfr!4v1234567896'
  },
  {
    code: '77',
    name: 'Seine-et-Marne',
    cities: ['Meaux', 'Melun', 'Chelles', 'Pontault-Combault', 'Savigny-le-Temple', 'Torcy'],
    delay: '70 min',
    description: 'Service de transport en Seine-et-Marne. Couverture étendue du plus grand département francilien.',
    mapUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d670583.57233022460!2d2.6889019!3d48.6066969!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e8e1f06e2b005%3A0x40b82c3688c9460!2sSeine-et-Marne!5e0!3m2!1sfr!2sfr!4v1234567897'
  }
];

const popularRoutes = [
  { from: 'Paris Centre', to: 'La Défense', time: '25 min', price: '35€' },
  { from: 'Gare du Nord', to: 'Aéroport Roissy CDG', time: '35 min', price: '55€' },
  { from: 'Paris 15e', to: 'Versailles', time: '40 min', price: '45€' },
  { from: 'Châtelet', to: 'Saint-Denis', time: '30 min', price: '40€' },
  { from: 'Bastille', to: 'Créteil', time: '35 min', price: '42€' },
  { from: 'Montparnasse', to: 'Aéroport Orly', time: '30 min', price: '48€' },
  { from: 'République', to: 'Montreuil', time: '25 min', price: '35€' },
  { from: 'Opéra', to: 'Neuilly-sur-Seine', time: '20 min', price: '32€' }
];

export default function ServiceZones() {
  const [selectedDept, setSelectedDept] = useState<Department>(departments[0]);

  return (
    <section id="zones" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            Pourquoi choisir notre service de transport en Île-de-France ?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Nous intervenons dans les 8 départements franciliens avec une expertise locale inégalée
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
          <div className="bg-white p-6 rounded-2xl shadow-lg text-center border border-gray-100">
            <div className="text-4xl font-black text-orange-600 mb-2">8</div>
            <div className="text-sm text-gray-600 font-medium">Départements couverts</div>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow-lg text-center border border-gray-100">
            <div className="text-4xl font-black text-orange-600 mb-2">1 300+</div>
            <div className="text-sm text-gray-600 font-medium">Communes desservies</div>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow-lg text-center border border-gray-100">
            <div className="text-4xl font-black text-orange-600 mb-2">12M</div>
            <div className="text-sm text-gray-600 font-medium">Habitants en IDF</div>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow-lg text-center border border-gray-100">
            <div className="text-4xl font-black text-orange-600 mb-2">30 min</div>
            <div className="text-sm text-gray-600 font-medium">Délai minimum Paris</div>
          </div>
        </div>

        {/* Avantages */}
        <div className="grid md:grid-cols-3 gap-8 mb-20">
          <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
            <div className="w-16 h-16 bg-orange-100 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-map-pin-line text-3xl text-orange-600"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">
              Une connaissance parfaite du trafic
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Nos chauffeurs connaissent parfaitement les routes, les raccourcis et les heures de pointe en Île-de-France. Nous optimisons chaque trajet pour garantir une livraison rapide, même aux heures de forte affluence.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
            <div className="w-16 h-16 bg-orange-100 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-truck-line text-3xl text-orange-600"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">
              Livraisons de dernier kilomètre
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Spécialistes de la livraison du dernier kilomètre en zone urbaine dense. Nous assurons la livraison finale jusqu'à votre porte, même dans les zones difficiles d'accès de la région parisienne.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
            <div className="w-16 h-16 bg-orange-100 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-time-line text-3xl text-orange-600"></i>
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900">
              Réactivité et ponctualité
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Service disponible 24h/24 et 7j/7 avec intervention rapide. Notre proximité géographique nous permet d'intervenir en moins de 30 minutes dans Paris et sous 1 heure dans toute l'Île-de-France.
            </p>
          </div>
        </div>

        {/* Department Selector */}
        <div className="bg-white rounded-3xl shadow-xl p-8 mb-16 border border-gray-100">
          <h3 className="text-3xl font-bold text-center mb-8 text-gray-900">
            Nos Zones d'Intervention en Île-de-France
          </h3>
          
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-3 mb-8">
            {departments.map((dept) => (
              <button
                key={dept.code}
                onClick={() => setSelectedDept(dept)}
                className={`p-4 rounded-xl font-bold transition-all duration-300 ${
                  selectedDept.code === dept.code
                    ? 'bg-gradient-to-r from-orange-500 to-red-500 text-white shadow-lg scale-105'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                <div className="text-2xl mb-1">{dept.code}</div>
                <div className="text-xs">{dept.name}</div>
              </button>
            ))}
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <h4 className="text-2xl font-bold mb-4 text-gray-900">
                {selectedDept.name} ({selectedDept.code})
              </h4>
              <p className="text-gray-600 mb-6 leading-relaxed">{selectedDept.description}</p>
              
              <div className="mb-6">
                <div className="flex items-center gap-3 mb-3">
                  <i className="ri-time-line text-2xl text-orange-600"></i>
                  <span className="font-semibold text-gray-900">Délai moyen :</span>
                  <span className="text-orange-600 font-bold">{selectedDept.delay}</span>
                </div>
              </div>

              <div>
                <h5 className="font-bold text-gray-900 mb-3">Principales villes desservies :</h5>
                <div className="flex flex-wrap gap-2">
                  {selectedDept.cities.map((city, index) => (
                    <span
                      key={index}
                      className="px-4 py-2 bg-orange-50 text-orange-700 rounded-full text-sm font-medium"
                    >
                      {city}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            <div className="rounded-2xl overflow-hidden shadow-lg h-96">
              <iframe
                src={selectedDept.mapUrl}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title={`Carte de ${selectedDept.name}`}
              ></iframe>
            </div>
          </div>
        </div>

        {/* Popular Routes */}
        <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-3xl p-8 border border-orange-100">
          <h3 className="text-3xl font-bold text-center mb-8 text-gray-900">
            Trajets les Plus Demandés en Île-de-France
          </h3>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {popularRoutes.map((route, index) => (
              <div key={index} className="bg-white p-6 rounded-xl shadow-md border border-gray-100">
                <div className="flex items-start gap-3 mb-4">
                  <i className="ri-map-pin-2-fill text-2xl text-orange-600 mt-1"></i>
                  <div className="flex-1">
                    <div className="font-bold text-gray-900 mb-1">{route.from}</div>
                    <i className="ri-arrow-down-line text-gray-400"></i>
                    <div className="font-bold text-gray-900 mt-1">{route.to}</div>
                  </div>
                </div>
                <div className="flex justify-between items-center pt-4 border-t border-gray-100">
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <i className="ri-time-line"></i>
                    <span>{route.time}</span>
                  </div>
                  <div className="text-lg font-bold text-orange-600">{route.price}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Liste des départements pour le SEO */}
        <div className="mt-16 bg-white rounded-2xl p-8 shadow-lg border border-gray-100">
          <h3 className="text-2xl font-bold text-center mb-8 text-gray-900">
            Nos Départements d'Intervention en Île-de-France
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div>
              <h4 className="font-bold text-orange-600 mb-3">Paris (75)</h4>
              <p className="text-sm text-gray-600">
                Transport et livraison express dans tous les arrondissements de Paris. Service coursier rapide disponible 24/7.
              </p>
            </div>
            <div>
              <h4 className="font-bold text-orange-600 mb-3">Hauts-de-Seine (92)</h4>
              <p className="text-sm text-gray-600">
                Livraison dans le 92 : Nanterre, Boulogne, Courbevoie, La Défense. Transport professionnel pour entreprises.
              </p>
            </div>
            <div>
              <h4 className="font-bold text-orange-600 mb-3">Seine-Saint-Denis (93)</h4>
              <p className="text-sm text-gray-600">
                Service de transport dans le 93 : Saint-Denis, Montreuil, Aubervilliers. Livraison zones industrielles.
              </p>
            </div>
            <div>
              <h4 className="font-bold text-orange-600 mb-3">Val-de-Marne (94)</h4>
              <p className="text-sm text-gray-600">
                Transport dans le 94 : Créteil, Vitry, Champigny. Coursier express pour particuliers et professionnels.
              </p>
            </div>
            <div>
              <h4 className="font-bold text-orange-600 mb-3">Essonne (91)</h4>
              <p className="text-sm text-gray-600">
                Livraison dans le 91 : Évry, Corbeil, Massy. Service de transport adapté aux zones d'activités.
              </p>
            </div>
            <div>
              <h4 className="font-bold text-orange-600 mb-3">Yvelines (78)</h4>
              <p className="text-sm text-gray-600">
                Transport dans le 78 : Versailles, Sartrouville, Saint-Germain. Livraison résidentielle et professionnelle.
              </p>
            </div>
            <div>
              <h4 className="font-bold text-orange-600 mb-3">Val-d'Oise (95)</h4>
              <p className="text-sm text-gray-600">
                Service dans le 95 : Cergy, Argenteuil, Pontoise. Transport rapide zones industrielles du nord.
              </p>
            </div>
            <div>
              <h4 className="font-bold text-orange-600 mb-3">Seine-et-Marne (77)</h4>
              <p className="text-sm text-gray-600">
                Livraison dans le 77 : Meaux, Melun, Chelles. Couverture complète du plus grand département francilien.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
